import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectSceneSelectionInterval } from '../../element-editor/store/selector/editor.selector';
import { setBackgroundDefinition } from '../../element-editor/store/editor.actions';
export type BgUIType = 'glow' | 'gradient' | 'static' | 'image' | 'video';

@Component({
  selector: 'nw-background-settings-modal',
  templateUrl: './background-settings-modal.component.html',
  styleUrls: ['./background-settings-modal.component.scss'],
})
export class BackgroundSettingsModalComponent {
  @Input() sceneIndexOptions: number[] = [];

  @Input() startIndex = 1;
  @Output() startIndexChange = new EventEmitter<number>();

  @Input() endIndex = 1;
  @Output() endIndexChange = new EventEmitter<number>();
  @Input() type: BgUIType = 'glow';
  @Output() typeChange = new EventEmitter<BgUIType>();
  @Output() cancel = new EventEmitter<void>();
  @Output() save = new EventEmitter<{
    startIndex: number;
    endIndex: number;
    type: BgUIType;
  }>();

  // UI state for type-specific forms (placeholder values)
  glowColor = '#ff8cff';
  glowIntensity = 60;

  gradientStart = '#ff6a00';
  gradientEnd = '#006aff';
  gradientAngle = 45;

  staticColor = '#5b9bd5';

  imageUrl = '';
  videoUrl = '';

  onStartIndexChange(v: number) {
    this.startIndex = Number(v);
    this.startIndexChange.emit(this.startIndex);
  }

  onEndIndexChange(v: number) {
    this.endIndex = Number(v);
    this.endIndexChange.emit(this.endIndex);
  }

  onTypeChange(v: BgUIType) {
    this.type = v;
    this.typeChange.emit(this.type);

    switch (v) {
      case 'glow':
        this.glowColor = '#ff8cff';
        this.glowIntensity = 60;
        this.store.dispatch(
          setBackgroundDefinition({
            id: '2',
            definition: {
              type: 'ellipse',
              options: {
                startAngle: '45',
                speed: 0.39269908169872414,
                radiusScale: 1.5,
                colors: ['#9660c4', '#379056'],
                gloveRadiusRatio: 1,
              },
            },
          }),
        );
        break;
      case 'gradient':
        this.gradientStart = '#ff6a00';
        this.gradientEnd = '#006aff';
        this.gradientAngle = 45;
        break;
      case 'static':
        this.staticColor = '#5b9bd5';
        break;
      case 'video':
        // this.store
        // -- //
        this.store.dispatch(
          setBackgroundDefinition({
            id: '1',
            definition: {
              type: 'video',
              options: {
                url: 'https://private.cdn.inwedio.com/stock_video.mp4',
              },
            },
          }),
        );
        break;
    }
  }

  onClose() {
    this.cancel.emit();
  }

  onSave() {
    this.save.emit({
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      type: this.type,
    });
  }

  selectionInterval$: Observable<[number, number]>;

  constructor(private readonly store: Store) {
    this.selectionInterval$ = this.store.select(selectSceneSelectionInterval);

    this.selectionInterval$.subscribe(val => {
      // console.log('selectionInterval', val);
    });
  }
}
